<template>
  <div class="row mb-2 py-1 bg-white shadow-sm mx-1">
    <div class="col-3 my-auto">{{ signatur.unterschrift }}</div>
    <div class="col-2 my-auto">{{ signatur.zeichnung }}</div>
    <div class="col-3 my-auto">{{ signatur.funktion }}</div>
    <div class="col-3 my-auto">{{ signatur.funktionEN }}</div>
    <div class="col-1 d-flex align-items-center justify-content-end">
      <router-link :to="{ name: 'DetailsSignatur', query: { signaturid: signatur.id } }" class="btn btn-primary"
        ><font-awesome-icon icon="chevron-right"
      /></router-link>
    </div>
  </div>
</template>

<script lang="ts" setup>
  //#region Imports
  import { PropType } from 'vue';
  import { Signatur } from '../../models/VertragspartnerModels';
  //#endregion

  const { signatur } = defineProps({
    signatur: {
      type: Object as PropType<Signatur>,
      required: true,
    },
  });
</script>
